<template>
  <div class="creation">
    <div>
      <h3
        class="creation__title">
        {{ $t('contact.creation.title')  }}
      </h3>
      <el-form
        class="creation__body"
        :model="form"
        :rules="rules"
        ref="contactForm"
        @submit.native.prevent="submitContact">
        <el-form-item prop="reason">
          <div slot="label">
            {{ $t('contact.creation.form.select') }}
          </div>
          <el-select v-model="form.type">
            <el-option
              :label="$t('contact.creation.form.type.help')"
              value="help"></el-option>
            <el-option
              :label="$t('contact.creation.form.type.disputes')"
              value="disputes"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('contact.creation.form.message')" prop="message">
          <el-input type="textarea" :rows="6" v-model="form.message"></el-input>
        </el-form-item>
        <el-form-item>
          <input-upload
            :id="'file-upload'"
            :text="$t('contact.creation.form.fileUpload')"
            :legend="$t('contact.creation.form.max')"
            :files.sync="form.files"
            multiple
          />
        </el-form-item>
        <el-form-item class="creation__body__submit">
          <el-button
            :loading="contactLoading"
            native-type="submit"
            type="primary"
            :disabled="contactLoading"
            @click="submitContact">
            {{ $t('contact.creation.addLabel')}}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InputUpload from '@/utils/components/InputUpload.vue';

export default {
  name: 'creation',
  components: {
    InputUpload,
  },
  data() {
    return {
      displayCreation: false,
      form: {
        message: '',
        files: [],
        type: 'help',
      },
      rules: {
        message: [
          {
            required: true,
            message: this.$t('contact.creation.form.messageWarning'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      contactDate: 'contactStore/contactDate',
      contactLoading: 'contactStore/contactLoading',
    }),
  },
  methods: {
    ...mapActions({
      postContact: 'contactStore/postContact',
    }),
    submitContact() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          this.createContact();
        }
      });
    },
    async createContact() {
      const formData = new FormData();
      formData.append('message', this.form.message);
      formData.append('service', this.form.type);
      for (let i = 0; i < this.form.files.length; i += 1) {
        formData.append('files', this.form.files[i]);
      }
      try {
        const result = await this.postContact(formData);
        if (result) {
          this.form.files = [];
          this.form.message = '';
        }
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.creation {
  &__title {
  }
  &__body {
    &__submit {
      text-align: right;
    }
  }
  &__contact-sent {
    text-transform: none;
    font-weight: 500;
  }
}

</style>
